import palette from 'constants/palette'
import { HamburgerNavState } from './types'

export const initialState: HamburgerNavState = {
  settings: {
    enabled: false,
    items: [],
    backgroundColor: palette.white,
    textColor: palette.black,
  },
  isLoading: false,
  hasChanges: false,
}

export default initialState
